export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12660.98ce1631.jpg";